import React, { useContext, useEffect, useState } from "react";
import Utils from "../../../../Common/Utils";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import AppSettings from "../../../../Settings/AppSettings";
import { AppContext } from "../../../../Context/AppContext";
import orderBy from "lodash/orderBy";
import ViewMoreButton from "../../../Common/components/ViewMoreButton";
import Accordion from "Components/DesignSystem/Accordion/Accordion";
import Typography from "Components/DesignSystem/Typography/Typography";
import Badge from "Components/DesignSystem/Badge/Badge";
import Tag from "Components/DesignSystem/Tag/Tag";
import ChoiceChip from "Components/DesignSystem/ChoiceChip/ChoiceChip";
import Tooltip from "Components/DesignSystem/Tooltip/Tooltip";
import Search from "Components/DesignSystem/Search/Search";
import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";
import Button from "Components/DesignSystem/Button/Button";
import EmptyState from "Components/DesignSystem/EmptyState/EmptyState";

/**
 * The edit-mode Categories chip picker — the attribute module's twin of the
 * category module's AssociatedAttributes picker, on the same DS grammar:
 * selected chips are Tags (a shared one is a meta Tag behind a Tooltip, not
 * removable), pickable chips are ChoiceChips (§ 193 danger tone for one whose
 * removal is pending), the type filter is a DS Dropdown and the search a DS
 * Search. Selection/filter/sort logic is verbatim from the Bootstrap version;
 * `Category.css` is gone with the btn-check markup it styled.
 */
// number of attributes to show at a time
const _max_items_show = 5;
const Category = ({
  setAssociatedCategory,
  existingCategory = [],
  attributeId,
  setSelectedCategory,
  setPrevSelectedCategory,
  saveMessage = null,
}) => {
  let appContext = useContext(AppContext);
  let [searchString, setSearchString] = useState("");
  const [sortedAttributeList, setSortedAttributeList] = useState([]);
  let [associatedAttributes, setAssociatedAttributes] =
    useState(existingCategory);

  let [filteredAttList, setFilteredAttList] = useState(sortedAttributeList);
  const [checkedAttributes, setCheckedAttributes] = useState(existingCategory);
  const [viewMoreCategories, setViewMoreCategories] = useState(false);
  const [viewSelCategories, setViewSelCategories] = useState(false);

  let industryId =
    appContext.get_selected_industry() && appContext.get_selected_industry().id;
  const [collapse1, setCollapse1] = useState(false);
  const [attributeList, setAttributeList] = useState(null);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [categoryTypes, setCategoryTypes] = useState([
    { name: "All Category Types", id: "none" },
  ]);
  const [optionsStateValue, setOptionsStateValue] = useState("none");
  const [categoryTypesAtt, setCategoryTypesAtt] = useState([]);
  const [showClearAllFlag, setshowClearAllFlag] = useState(true);

  useEffect(() => {
    setCheckedAttributes(existingCategory);
    const sharedFlag = checkSharedCategories(existingCategory);
    setshowClearAllFlag(sharedFlag);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existingCategory.length > 0]);

  useEffect(() => {
    load_Attributes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId]);

  function updateCategories(filteredCatAttList, checkedCatArray) {
    for (const catObject of checkedCatArray) {
      filteredCatAttList = filteredCatAttList.filter((item) => {
        return item.id !== catObject.id;
      });
    }
    return filteredCatAttList;
  }

  useEffect(() => {
    if (searchString === "") {
      // const catFinalData = updateCategories(filteredAttList, existingCategory);
      let catFinalData = updateCategories(filteredAttList, checkedAttributes);
      catFinalData = sortCatArray(catFinalData);
      setFilteredAttList(catFinalData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString]);

  useEffect(() => {
    setCheckedAttributes([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributeId === null]);

  useEffect(() => {
    setSelectedCategory(checkedAttributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedAttributes]);

  async function handleSearchAttribute(value) {
    setSearchString(value);
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = sortedAttributeList.filter((item) => {
        return (
          (item.name != null && item.name.toLowerCase().includes(searchval)) ||
          (item.description != null &&
            item.description.toLowerCase().includes(searchval))
        );
      });
      let catFinalData = updateCategories(filteredData, checkedAttributes);
      catFinalData = mapDeletedItem(catFinalData);
      catFinalData = sortCatArray(catFinalData);
      setFilteredAttList(catFinalData);
    } else {
      let catFinalData = updateCategories(
        sortedAttributeList,
        checkedAttributes
      );
      catFinalData = mapDeletedItem(catFinalData);
      catFinalData = sortCatArray(catFinalData);
      setFilteredAttList(catFinalData);
    }

    const categoryTypesAttArr = updateCategories(
      sortedAttributeList,
      checkedAttributes
    );
    setCategoryTypesAtt(categoryTypesAttArr);
  }

  function handle_collapse() {
    setCollapse1(!collapse1);
  }

  async function load_Attributes(showStatus = true) {
    if (showStatus) {
      setLoading({
        status: "Loading",
        message: "Loading Categories",
      });
    }
    // /category/getbyindustryid/<industryid></industryid>
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}category/getbyindustryid/${industryId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      await setAttributeList(ret.data.data);
      let catData = ret.data.data;
      // setFilteredAttList(ret.data.data);
      existingCategory = mapExistingCategories(catData, existingCategory);
      setPrevSelectedCategory(existingCategory);
      setCheckedAttributes(existingCategory);
      setAssociatedCategory(ret.data.data);

      if (catData?.length > 0) {
        const allUnckedCategories = updateCategories(catData, existingCategory);
        const catFinalData = sortCatArray(allUnckedCategories);
        setFilteredAttList(catFinalData);
      }

      // fetch Categories type
      const catTypes = await ServiceWrapper.doGet(
        `${api_base_url}categorytype/getbyindustryid/${industryId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );

      let catTypesArr = [];
      if (!catTypes.errorfound) {
        catTypesArr = catTypes?.data?.data;
        setCategoryTypes([...categoryTypes, ...catTypesArr]);
      }

      setLoading({
        status: "Success",
        message: undefined,
      });
    } else {
      setLoading({
        status: "Error",
        message: "Error while Loading Attributes",
      });
    }
  }

  function mapExistingCategories(allCatItemsArr, existingCatArr) {
    const arr = [];
    existingCatArr.forEach((item) => {
      for (const catItem of allCatItemsArr) {
        if (item.id === catItem.id) {
          catItem.shared = item.shared;
          arr.push(catItem);
          break;
        }
      }
    });
    return arr;
  }

  useEffect(() => {
    if (optionsStateValue === "none" && searchString === "") {
      if (sortedAttributeList.length > 0) {
        const filteredCategoryArrData = updateCategories(
          sortedAttributeList,
          checkedAttributes
        );
        const catFinalData = sortCatArray(filteredCategoryArrData);
        setFilteredAttList(catFinalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsStateValue]);

  function getChecked(id) {
    let obj = checkedAttributes.find((att) => att.id === id);
    return obj !== undefined;
  }

  useEffect(() => {
    let arr = [];
    if (
      associatedAttributes &&
      associatedAttributes.length > 0 &&
      attributeList
    ) {
      attributeList.map((i) => {
        let obj = associatedAttributes.find((att) => att.id === i.id);
        if (obj !== undefined) {
          arr.unshift(i);
        } else {
          arr.push(i);
        }
        return true;
      });
    } else if (attributeList) {
      arr = [...attributeList];
    }

    setSortedAttributeList(arr);
    if (attributeId === "0") {
      setSortedAttributeList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributeList, attributeId !== "0"]);

  const fromSelectedToAllCategory = (categoryItem) => {
    categoryItem.removed_from_selected = true;
    let index = checkedAttributes.findIndex(
      (att) => att.id === categoryItem.id
    );
    if (index === -1) {
      setCheckedAttributes([...checkedAttributes, categoryItem]);
    } else {
      let checkedArr = [...checkedAttributes];
      checkedArr.splice(index, 1);
      setCheckedAttributes(checkedArr);
      if (categoryTypesAtt.length >= filteredAttList.length) {
        let existingFlag = 0;
        const updatedCategoryTypesAtt = categoryTypesAtt.map((item) => {
          if (item.id === categoryItem.id) {
            existingFlag = 1;
            item.removed_from_selected = true;
          }
          return item;
        });
        if (existingFlag === 0) {
          setCategoryTypesAtt([...updatedCategoryTypesAtt, categoryItem]);
        } else {
          setCategoryTypesAtt(updatedCategoryTypesAtt);
        }
      }
      const catArrData = sortCatArray([...filteredAttList, categoryItem]);
      setFilteredAttList(catArrData);
      // To reset search and filter when there is no data found in selected categories
      if (searchString !== "") {
        setSearchString("");
        const allUnckedCategories = updateCategories(
          sortedAttributeList,
          checkedArr
        );
        const catArrData = sortCatArray(allUnckedCategories);
        setFilteredAttList(catArrData);
      }
      setOptionsStateValue("none");
      const sharedFlag = checkSharedCategories(checkedArr);
      setshowClearAllFlag(sharedFlag);
    }
  };

  const clearAllCheckedItems = () => {
    let clearCheckedItems = checkedAttributes.map((item) => {
      item.removed_from_selected = true;
      return item;
    });
    const sharedCategories = clearCheckedItems.filter((item) => item.shared);
    clearCheckedItems = clearCheckedItems.filter((item) => !item.shared);
    const actualFilteredArrData = updateCategories(
      sortedAttributeList,
      clearCheckedItems
    );
    const catArrData = sortCatArray([...filteredAttList, ...clearCheckedItems]);
    setFilteredAttList(catArrData);
    setCategoryTypesAtt([...actualFilteredArrData, ...clearCheckedItems]);
    setCheckedAttributes(sharedCategories);

    if (searchString !== "") {
      setSearchString("");
      const catArrData = sortCatArray(sortedAttributeList);
      setFilteredAttList(catArrData);
    }
    setOptionsStateValue("none");
    // const sharedFlag = checkSharedCategories(checkedAttributes)
    setshowClearAllFlag(false);
  };

  const filterCategories = (category_id) => {
    setSearchString("");
    setOptionsStateValue(category_id);
    let actualCategoryData =
      categoryTypesAtt.length > 0 ? categoryTypesAtt : filteredAttList;

    if (category_id !== "none") {
      let filteredCategoriesData = actualCategoryData?.filter((item) => {
        return item.cattype === category_id;
      });
      actualCategoryData = updateCategories(
        actualCategoryData,
        checkedAttributes
      );
      setCategoryTypesAtt(actualCategoryData);
      filteredCategoriesData = mapDeletedItem(filteredCategoriesData);
      const catArrData = sortCatArray(filteredCategoriesData);
      setFilteredAttList(catArrData);
      // [categoryTypesAtt,setCategoryTypesAtt]
    } else {
      actualCategoryData = updateCategories(
        categoryTypesAtt,
        checkedAttributes
      );
      actualCategoryData = mapDeletedItem(actualCategoryData);
      const catArrData = sortCatArray(actualCategoryData);
      setFilteredAttList(catArrData);
      setCategoryTypesAtt([]);
    }
  };

  function mapDeletedItem(categoryArr) {
    for (const cat of existingCategory) {
      categoryArr = categoryArr.map((item) => {
        if (item.id === cat.id) {
          item.removed_from_selected = true;
        }
        return item;
      });
    }
    return categoryArr;
  }
  function sortCatArray(catArr) {
    catArr = orderBy(catArr, ["name"], ["asc"]);
    return catArr;
  }

  function checkSharedCategories(allCategoriesArr) {
    let sharedFlag = false;
    allCategoriesArr.map((item) => {
      if (!item.shared) {
        sharedFlag = true;
      }
      return true;
    });
    return sharedFlag;
  }

  return (
    <Accordion
      title="Categories"
      open={collapse1}
      onOpenChange={() => handle_collapse()}
      data-testid="componets-category-div-1"
      variant="boxed"
    >
      <div className="tw-pb-4">
        <div className="tw-border tw-border-edge tw-rounded-ctl tw-overflow-hidden">
          {/* Only the band HEADER is sunken (the AssociatedAttributes twin's
              structure) — accent-tint chips on the sunken ground barely read
              (user-reported 2026-09-01), so the chips sit on plain surface. */}
          <div>
            <div className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-surface-sunken">
              <Typography variant="title-header" as="h3" className="tw-mb-0 tw-text-ink">
                Selected Categories
              </Typography>
              <Badge variant="secondary">{checkedAttributes?.length}</Badge>
            </div>
            <div className="tw-p-4">
              <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                {checkedAttributes && checkedAttributes.length > 0 ? (
                  <>
                    {checkedAttributes
                      .slice(
                        0,
                        viewSelCategories
                          ? checkedAttributes.length
                          : Math.min(
                              _max_items_show,
                              checkedAttributes.length
                            )
                      )
                      .map((item, index) =>
                        !item.shared ? (
                          <Tag
                            key={item?.name + index}
                            label={item.name}
                            data-testid={`attribute-category-selected-${item.id}`}
                            removeLabel="Remove category"
                            onRemove={() => fromSelectedToAllCategory(item)}
                          />
                        ) : (
                          <Tooltip
                            key={item?.name + index}
                            content="Attribute associated with categories, products, rules or builder cannot be removed."
                            placement="bottom"
                          >
                            <Tag
                              label={item.name}
                              variant="meta"
                              data-testid={`attribute-category-selected-${item.id}`}
                            />
                          </Tooltip>
                        )
                      )}
                  </>
                ) : (
                  <Typography variant="body-primary" className="tw-mb-0 tw-text-ink-secondary">
                    No Categories found
                  </Typography>
                )}
                <ViewMoreButton
                  state={viewSelCategories}
                  handleClick={() =>
                    setViewSelCategories(!viewSelCategories)
                  }
                  condition={checkedAttributes?.length > _max_items_show}
                />
              </div>
              {checkedAttributes?.length > 0 && showClearAllFlag ? (
                <Button
                  variant="subtle"
                  size="sm"
                  className="tw-mt-2"
                  data-testid="componets-category-span-3"
                  onClick={clearAllCheckedItems}
                >
                  Clear All
                </Button>
              ) : null}
            </div>
          </div>

          <div className="tw-border-t tw-border-edge">
            <div className="tw-flex tw-flex-wrap tw-justify-between tw-items-center tw-gap-3 tw-px-4 tw-py-2 tw-bg-surface-sunken">
              <Typography variant="title-header" as="h3" className="tw-mb-0 tw-text-ink">
                Select Categories
              </Typography>
              <div className="tw-flex tw-items-center tw-gap-3">
                <Dropdown
                  label=""
                  size="sm"
                  className="tw-w-52"
                  data-testid="attribute-category-filter-select"
                  /* The picker box is tw-overflow-hidden (it clips the sunken
                     band's corners), which also clipped the open listbox —
                     user-reported 2026-09-01. The portal takes the menu out of
                     the clip context (RuleCategorySelector precedent). */
                  usePortal
                  options={categoryTypes.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  value={optionsStateValue}
                  onChange={(value) => filterCategories(value)}
                />
                <Search
                  size="sm"
                  className="tw-w-56"
                  placeholder="Search Category"
                  ariaLabel="Search categories"
                  data-testid="componets-category-input-1"
                  value={searchString}
                  onChange={(value) => handleSearchAttribute(value)}
                />
              </div>
            </div>
            <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-p-4">
              {filteredAttList && filteredAttList.length > 0 ? (
                <>
                  {filteredAttList
                    .slice(
                      0,
                      viewMoreCategories || searchString !== ""
                        ? filteredAttList.length
                        : Math.min(10, filteredAttList.length)
                    )
                    .map((item, index) => (
                      <ChoiceChip
                        key={index + item.id}
                        label={item.name}
                        selected={
                          !!(
                            checkedAttributes &&
                            checkedAttributes.length > 0 &&
                            getChecked(item.id)
                          )
                        }
                        /* § 193: was associated before this edit — adding it back
                           restores a saved association. Legacy drew this as
                           btn-outline-danger. */
                        tone={item?.removed_from_selected ? "danger" : "default"}
                        data-testid={`componets-category-input-3-${item.id}`}
                        onClick={() => {
                          setshowClearAllFlag(true);
                          let index = checkedAttributes.findIndex(
                            (att) => att.id === item.id
                          );

                          // Remove category from filterdeCategories
                          let filteredCategories =
                            filteredAttList.filter((catObject) => {
                              return item.id !== catObject.id;
                            });

                          setFilteredAttList([...filteredCategories]);

                          if (index === -1) {
                            // let { id, name } = item;
                            setCheckedAttributes([
                              ...checkedAttributes,
                              item,
                            ]);
                          } else {
                            let checkedArr = [...checkedAttributes];
                            checkedArr.splice(index, 1);
                            setCheckedAttributes(checkedArr);
                          }
                        }}
                      />
                    ))}
                  <ViewMoreButton
                    state={viewMoreCategories}
                    handleClick={() =>
                      setViewMoreCategories(!viewMoreCategories)
                    }
                    condition={
                      searchString === "" &&
                      filteredAttList?.length > _max_items_show
                    }
                  />
                </>
              ) : (
                <>
                  {searchString !== "" ? (
                    <EmptyState
                      size="sm"
                      className="tw-w-full"
                      data-testid="attribute-category-no-match"
                      title="Sorry! No Category found matching your search query"
                    />
                  ) : (
                    <Typography variant="body-primary" className="tw-mb-0 tw-text-ink-secondary">
                      No Categories found
                    </Typography>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Accordion>
  );
};

export default Category;
